import styled from 'styled-components';


export const AuthenticationContainer = styled.div`

display: flex;
width: 900px;
justify-content: space-between;
margin: 30px auto;


`;

export const IllustrationImage = styled.img`
    width: 300px; 
    height: 450px; 
`;

export const IllustrationImage2 = styled.img`
    width: 400px; 
    height: 450px; 
`;
